import React from 'react';

// styling
import './PointsWatching.css';

// constants
import { POINTS_WATCHING, POINTS_WATCHING_CUSTOMER_FIELDS } from './constants';

// custom components
import TopToolbar from '../global/subcomponents/topToolbar/TopToolbar';

// mui components and icons
import { CircularProgress, TableCell, TextField } from '@material-ui/core';
import TablePage from '../global/Table/TablePage';
import { Layout } from '../global/Table/TablePageHelpers/LayoutObject';
import { ASC, DESC } from '../global/constants';
import { DEFAULT_SORT_BY_HEAD_CELL } from '../employeeSession/constants';
import FilterTagsBar from '../global/FilterTagsBar';
import Slide from '@material-ui/core/Slide';
import Tooltip from '@material-ui/core/Tooltip';
import { IconButton } from '@mui/material';
import FilterIcon from '../global/FilterIcon';
import PointsWatchingFiltersDialog from './PointsWatchingFiltersDialog';
import SearchableTable from '../global/Search/SearchableTable';
import Utils from '../Utils/Utils';
import withShipment from '../../withShipment';
import Autocomplete from '@material-ui/lab/Autocomplete';


class PointsWatchingTable extends SearchableTable{
    constructor(props) {
        super(props);
        this.state = {
            deleteId: null,
            selectedRowIndex: null,
            selectedEntries: [],
            isSelecting: false,
            isSearch: false,
            searchValue: "",
            order: DESC,
            orderBy: DEFAULT_SORT_BY_HEAD_CELL,
            shownIndex: -1,
            fromDate: this.props.fromDate,
            toDate: this.props.toDate,
            filtersMap: {},
            showFilters: false,
            filtersMapBeforeOpenDialog: {},
            deletedTagsWithCookies: [],
            selectedCustomers: [],
            customerDetailView: null,
            selectedEmployee: null,
            isLoading: true,
        }
        this.onSearchValueChange = this.onSearchValueChange.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.handleRequestSort = this.handleRequestSort.bind(this)
        this.getDisplayed = this.getDisplayed.bind(this)
    }


    getContextualMenuItems = () => {
        return [];
    }


    async componentDidMount() {
        let changeBack = false
        await this.setState({
            searchValue: this.props.searchText,
        })
        let storage = JSON.parse(localStorage.getItem("pointsWatching"))
        if (storage) {

            this.getNewDates()
            const expiry = parseInt(JSON.parse(localStorage.getItem("expiry")))
            if (storage.fromDate !== null && storage.fromDate !== undefined) {
                if (expiry > new Date().getTime()) {
                    this.onFiltersClose(true, false)
                } else {
                    changeBack = true
                }
            }
            if (storage.toDate !== null && storage.toDate !== undefined) {
                if (expiry > new Date().getTime()) {
                    this.onFiltersClose(true, false)
                } else {
                    changeBack = true
                }
            }
            if (changeBack) {
                localStorage.removeItem("pointsWatching")
                this.setState({
                    fromDate: this.getFromDate(),
                    toDate: this.getToDate(),
                    filtersMap: {}
                })
            }
        }

        if(this.props.setFetchedList){
            // this.props.fetchPointWatching({
            //     fromDate: this.state.fromDate,
            //     toDate:  this.state.toDate,
            //     userId: this.user.userId
            // })
        }

    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (prevProps.searchText !== this.props.searchText || this.state.searchValue !== this.props.searchText) {
            this.initializeSearchText()
        }

    }

    initializeSearchText = () => {
        this.setState({ searchValue: this.props.searchText })
    }

    onSearchValueChange(e) {
        this.setState({
            isSearch: e.target.value.length > 0,
            searchValue: e.target.value
        });
        this.props.setPage(0)
        this.props.handleSearchChange(e)
    };

    getFromDate = () => {
        const date = new Date();
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setDate(date.getDate() - 7)
        return date;
    }

    getToDate = () => {
        const date = new Date();
        date.setHours(23);
        date.setMinutes(59);
        date.setSeconds(59);
        return date;
    }

    getNewDates = () => {
        let filter = {...this.state.filtersMap}
        let storage = JSON.parse(localStorage?.getItem("pointsWatching"))
        if (storage.fromDate !== null && storage.fromDate !== undefined ) {
            const temp = new Date(storage.fromDate)
            filter.fromDate = temp;
            this.setState({
                fromDate: temp
            }, ()=>{
                this.props.handleDateChange(this.state.fromDate,"fromDate")
            })
        }
        if (storage.toDate !== null && storage.toDate !== undefined) {
            const temp = new Date(storage.toDate)
            filter.toDate = temp;
            this.setState({
                toDate: temp
            },()=>{
                this.props.handleDateChange(this.state.toDate,"toDate")
            })
        }

        if (filter) {
            this.setState({
                filtersMap: filter,
            })
        }
    }

    isDefaultFromDate = (someDate) => {
        const defaultFromDate = this.getFromDate()
        return someDate.getDate() === defaultFromDate.getDate() &&
            someDate.getMonth() === defaultFromDate.getMonth() &&
            someDate.getFullYear() === defaultFromDate.getFullYear()
    }


    isToday = (someDate) => {
        const today = new Date()
        return someDate.getDate() === today.getDate() &&
            someDate.getMonth() === today.getMonth() &&
            someDate.getFullYear() === today.getFullYear()
    }


    handleChangePage = (event, newPage) => {
        this.props.setPage(newPage)
    };
    handleChangeRowsPerPage = (event) => {
        this.props.setRowsPerPage(event.target.value)
        this.props.setPage(0)
    };
    handleRequestSort = (event, property) => {
        const isAsc = this.state.orderBy === property && this.state.order === ASC;
        this.setState({
            order: isAsc ? DESC : ASC,
            orderBy: property,
        });
    };
    getDisplayed = (rows) => {
        if (!rows)
            return [];
        return [...rows.slice(this.props.page * this.props.rowsPerPage, (this.props.page + 1) * this.props.rowsPerPage)];
    }


    numSelected(checkedEntries) {
        let rows = this.getDisplayed(this.stableSort(this.applyOverviewFilters(this.filterBySearch(this.props.data)), this.getComparator(this.state.order, this.state.orderBy)))
        return rows.reduceRight((accum, curr) => accum + (checkedEntries[curr.clockId] ?? 0), 0)
    }

    toggleFiltersDialog = () => {
        this.setState({
            showFilters: !this.state.showFilters,
            filtersMapBeforeOpenDialog: { ...this.state.filtersMap }
        })
    }

    onFiltersInputChange = (name, val) => {
        const filtersMap = { ...this.state.filtersMap };

        // if filter already exists, then update
        if (val !== "" && val.length !== 0) {
            filtersMap[name] = val;
        }
        else {
            delete filtersMap[name];
        }

        this.saveUpdatedStatus(filtersMap)

        this.setState({
            filtersMap: filtersMap,
        });

    }

    saveUpdatedStatus = (filters) => {
        delete filters['fromDate']
        delete filters['toDate']
    }

    handleDateChange = (date, key) => {
        const filtersMap = { ...this.state.filtersMap };
        if ((key === 'fromDate' && !this.isDefaultFromDate(date)) ||
            (key === 'toDate' && !this.isToday(date))) {
            filtersMap[key] = date;
        } else {
            delete filtersMap[key]
        }
        this.setState({
            filtersMap: filtersMap,
            [key]: date
        })
        this.props.handleDateChange(date, key)
    }

    onFiltersClose = (applyFilters, saveFilterSetting) => {
        // NOTE: changes are already applied as the user makes these changes,
        // but if the changes are cancelled, then the map is reverted to its
        // previous state
        this.setState({
            showFilters: false,
        })
        let filters = {}
        if (!applyFilters) {
            filters = { ...this.state.filtersMapBeforeOpenDialog }
            this.resetDateFilters(filters?.fromDate ?? this.getFromDate(), filters?.toDate ?? this.getToDate(), filters)
        } else {
            if (this.state.deletedTagsWithCookies.length > 0) {
                let storage = JSON.parse(localStorage.getItem("pointsWatching"))
                this.state.deletedTagsWithCookies.forEach((tagName) => {
                    delete storage[tagName]
                })
                localStorage.setItem("pointsWatching", JSON.stringify(storage))
                if(JSON.stringify(storage) === JSON.stringify({})) localStorage.removeItem("pointsWatching")
                this.setState({deletedTagsWithCookies: []})
            }
            filters = { ...this.state.filtersMap }
            const expiry = new Date().setHours(23, 59, 59, 0);
            let needRefresh = this.props.fetchedList
            if (filters.fromDate !== null && filters.fromDate !== undefined) {
                let existing = localStorage.getItem("pointsWatching")
                existing = existing ? JSON.parse(existing) : {};
                if(existing.fromDate!==filters.fromDate.toISOString()) {
                    needRefresh = true
                }
                existing.fromDate = filters.fromDate;
                localStorage.setItem("pointsWatching", JSON.stringify(existing));
                localStorage.setItem("expiry", JSON.stringify(expiry))
            }
            if (filters.toDate !== null && filters.toDate !== undefined) {
                let existing = localStorage.getItem("pointsWatching")
                existing = existing ? JSON.parse(existing) : {};
                if(existing.toDate!==filters.toDate.toISOString()) {
                    needRefresh = true
                }
                existing.toDate = filters.toDate;
                localStorage.setItem("pointsWatching", JSON.stringify(existing));
                localStorage.setItem("expiry", JSON.stringify(expiry))
            }
            //fetching all the employee session
            if (this.props.data.length===0||needRefresh){
                // this.props.fetchPointWatching(this.state.fromDate, this.state.toDate)
                this.props.setFetchedList(false)
            }
        }
        if (saveFilterSetting) {
            this.saveUpdatedStatus(filters)
        }
    }

    resetDateFilters = (fromDate, toDate, filters) => {
        if (!this.isDefaultFromDate(fromDate)) {
            filters['fromDate'] = fromDate
        } else {
            delete filters['fromDate']
            fromDate = this.getFromDate()
        }
        if (!this.isToday(toDate)) {
            filters['toDate'] = toDate
        } else {
            delete filters['toDate']
            toDate = this.getToDate()
        }
        this.setState({
            fromDate: fromDate,
            toDate: toDate,
            filtersMap: filters,
            deletedTagsWithCookies: [],
        })
        this.props.handleDateChange(fromDate, 'fromDate')
        this.props.handleDateChange(toDate, "toDate")
    }

    onTagClickedWhenDialogueOpen = (event, tag) => {
        const filtersMap = { ...this.state.filtersMap };
        let tagValue = filtersMap[tag]
        let deletedTagsWithCookies = this.state.deletedTagsWithCookies
        delete filtersMap[tag];
        if (tag === 'fromDate') {
            let storage = JSON.parse(localStorage.getItem('pointsWatching'))
            if (storage) {
                if (storage.fromDate !== null && storage.fromDate !== undefined) {
                    if (new Date(storage.fromDate).getTime() === new Date(tagValue).getTime()) {
                        this.setState({deletedTagsWithCookies: [...deletedTagsWithCookies, "fromDate"]})
                    }
                }
            }
            this.setState({
                fromDate: this.getFromDate()
            })
        }
        if (tag === 'toDate') {
            let storage = JSON.parse(localStorage.getItem('pointsWatching'))
            if (storage) {
                if (storage.toDate !== null && storage.toDate !== undefined) {
                    if (new Date(storage.toDate).getTime() === new Date(tagValue).getTime()) {
                        this.setState({deletedTagsWithCookies: [...deletedTagsWithCookies, "toDate"]})
                    }
                }
            }
            this.setState({
                toDate: this.getToDate()
            })
        }
        this.saveUpdatedStatus(filtersMap)
        this.setState({
            filtersMap: filtersMap,
        });
    }

    onTagClicked = (event, tag) => {

        // remove the key from the filters map
        // clone the map, delete the key, set the state
        const filtersMap = { ...this.state.filtersMap };
        delete filtersMap[tag];
        if (tag === 'fromDate') {
            let storage = JSON.parse(localStorage.getItem('pointsWatching'))
            delete storage.fromDate
            this.setState({
                fromDate: this.getFromDate()
            }, () => this.props.fetchPointWatching(this.state.fromDate, this.state.toDate))
            localStorage.setItem("pointsWatching", JSON.stringify(storage))
            if(JSON.stringify(storage) === JSON.stringify({})) localStorage.removeItem("pointsWatching")
        }
        if (tag === 'toDate') {
            let storage = JSON.parse(localStorage.getItem('pointsWatching'))
            delete storage.toDate
            this.setState({
                toDate: this.getToDate()
            }, () => null
                // this.props.fetchPointWatching(this.state.fromDate, this.state.toDate)
            )
            localStorage.setItem("pointsWatching", JSON.stringify(storage))
            if(JSON.stringify(storage) === JSON.stringify({})) localStorage.removeItem("pointsWatching")
        }

        this.saveUpdatedStatus(filtersMap)
        this.setState({
            filtersMap: filtersMap,
        });
    }


    applyOverviewFilters = (rows) => {
        const selectedState = this.state.filtersMap?.state || []
        if (selectedState.length > 0) {
            rows = rows.filter(row => {
                return selectedState.includes(row.state);
            })
        }
        return rows
    }


    removeStatusFilters = () => {
        let filters = { ...this.state.filtersMap }
        delete filters['selectedStatus']
        return filters
    }

    clearFiltersMap = () => {
        this.setState({
            dateFiltersMap: {},
            fromDate: this.getFromDate(),
            toDate: this.getToDate()
        })
    }



    getCustomerTableHeaders = () => {
        let headers = []
        POINTS_WATCHING_CUSTOMER_FIELDS.forEach((headCell) => {
            headers.push(Layout.columnHead(headCell.label, headCell.id))
        })
        return headers
    }




    handleEmployee(data) {

        if (data) {
            this.setState({
                selectedCustomers: [],
                selectedEmployee: data
            });

            const newEntries = { [data.userId]: true };
            this.props.setSelected(newEntries, !!this.numSelected(newEntries), data);
        } else {

            this.setState({
                selectedEmployee: null,
                selectedCustomers: []
            });
            this.props.setSelected({}, false, null);
        }
    }

    handleImageLoad = () => {
        this.setState({ isLoading: false });
    };

    handleImageError = () => {
        this.setState({ isLoading: false }); // Optionally handle errors like showing a fallback image
    };


    tableCustomerRow = (data, index) => {

      const url =  Array.isArray(data.customer.photos) && data.customer.photos.length > 0
          ? data.customer.photos[0].localURL
              .replace('/home/kingdom_fs/', '')
          : ''

        return (
            <React.Fragment key={index}>

                <TableCell className="table-cell-left">
                </TableCell>

                <TableCell className="table-cell-left">
                    {this.state.isLoading && (
                        <div className="loading-indicator">
                            <CircularProgress/>
                        </div>
                    )}
                    <img
                        src={url}
                        alt=""
                        className="responsive-image-customerr"
                        onLoad={this.handleImageLoad}
                        onError={this.handleImageError}
                    />
                </TableCell>

                <TableCell className="table-cell-left">
                    {this.state.isLoading && (
                        <div className="loading-indicator">
                            <CircularProgress/>
                        </div>
                    )}
                    <img
                        src={Array.isArray(data?.customer?.files) && data.customer.files.length > 0 ? data.customer.files[0].localURL : ''}

                        alt=""
                        className="responsive-image-customerr"
                        onLoad={this.handleImageLoad}
                        onError={this.handleImageError}
                    />
                </TableCell>


                <TableCell
                    className="table-cell-left"
                >
                    {data?.customer?.firstName + " " + data?.customer?.lastName}
                </TableCell>

                <TableCell className="table-cell-left">
                    {data?.points}
                </TableCell>

                <TableCell className="table-cell-left">
                    {data?.signInDate}{' '}
                    {Utils.convertTo12HourFormat(data?.signInTime)}
                </TableCell>

                <TableCell className="table-cell-left">
                    {data?.ticket}
                </TableCell>

                <TableCell className="table-cell-left">
                    {data?.type}
                </TableCell>

            </React.Fragment>
        );
    };


    searchStrings = (data) => {
        const { firstName, lastName } = data.customer || {};
        const fullName = `${firstName} ${lastName}`.trim();

        return [
            firstName,
            fullName
        ];
    };

    render() {
        let rows = this.getDisplayed(this.stableSort(this.filterBySearch(this.applyOverviewFilters(this.props.data)), this.getComparator(this.state.order, this.state.orderBy)))

        return (
          <React.Fragment>
            <TopToolbar
              pageName={POINTS_WATCHING}
              menuItems={this.getContextualMenuItems()}
            />


              <div >
                <div className="filter-tag-wrapper space-date">
                  <FilterTagsBar
                    filtersMap={this.removeStatusFilters()}
                    onClick={
                      this.state.showFilters
                        ? this.onTagClickedWhenDialogueOpen
                        : this.onTagClicked
                    }
                  />
                </div>


                <div className="rowSpecWatching">

                    <Tooltip title={'Filter'}>
                        <IconButton
                            className="filterButton"
                            size="small"
                            aria-label={'Filter'}
                            onClick={this.toggleFiltersDialog}
                        >
                            <FilterIcon />
                        </IconButton>
                    </Tooltip>

                    <Autocomplete
                        className="point-input-width k"
                        options={rows}
                        getOptionLabel={(row) => row.firstname || ''}
                        autoHighlight
                        disableClearable={false} // allow clearing with "x"
                        onChange={(event, value) => {
                            this.setState({
                                selectedEmployee: value,
                                selectedDate: null
                            });
                            this.handleEmployee(value);
                        }}
                        blurOnSelect
                        filterOptions={(options) => options}
                        value={this.state.selectedEmployee
                            ? rows.find(r => r.userId === this.state.selectedEmployee.userId)
                            : null}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Select Employee"
                                InputLabelProps={{ shrink: true }}
                                variant="outlined"
                                name="employee"
                            />
                        )}
                    />


                    {this.props.pointsWatching.length > 0 && (
                        <div className="point-input-width ss"
                        >
                            <Autocomplete
                                options={Array.from(
                                    new Set(this.props.pointsWatching.map(item => item.date))
                                )}
                                getOptionLabel={(option) => option}
                                onChange={(event, value) => {
                                    this.setState({ selectedDate: value }, () => {
                                        const match = (this.props.pointsWatching || []).find(
                                            (item) => item.date === value
                                        );

                                        const customerPendingList = match?.customerPendingList ?? [];

                                        this.setState({ selectedCustomers: customerPendingList });

                                    });
                                }}
                                value={this.state.selectedDate || null}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select Date"
                                        variant="outlined"
                                        InputLabelProps={{ shrink: true }}
                                    />
                                )}
                                clearOnEscape
                            />
                        </div>
                    )}

                </div>


                  <Slide
                      in={this.state.showFilters}
                      mountOnEnter
                      unmountOnExit
                      timeout={300}
                  >
                      <PointsWatchingFiltersDialog
                          open={this.state.showFilters}
                          onClose={this.onFiltersClose}
                          onChange={this.onFiltersInputChange}
                          handleDateChange={this.handleDateChange}
                          filtersMap={this.state.filtersMap}
                          clearFilters={this.clearFiltersMap}
                          onTagClicked={this.onTagClicked}
                          fromDate={this.state.fromDate}
                          toDate={this.state.toDate}
                      />
                  </Slide>


                  {this.state.selectedCustomers.length > 0 && (
                    <div>

                        <TablePage
                            tableName="CustomerTable"
                            tableRows={this.state.selectedCustomers}
                            tableColumnHeads={this.getCustomerTableHeaders()}
                            tableRow={this.tableCustomerRow}
                            paginationText="Results"
                            defaultSortBy="firstname"
                            searchStrings={this.searchStrings}
                            hasSearchField
                        />

                    </div>
                  )}
                </div>

          </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
})


const actionCreators = {
}

export default withShipment({
    actionCreators,
    mapStateToProps
}, PointsWatchingTable);

